import React from 'react';
import './CreateFood.css';
import profile from '../../images/splash/user.png';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { image_api, var_api } from '../constant';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Layout from '../NewHeader/Layout';
import cimage from '../../images/burger/b1.png';
import Pagination from 'react-js-pagination';
import {  Form } from 'react-bootstrap';
import { config } from '@fortawesome/fontawesome-svg-core';


const CreateFood = () => {
  const history = useHistory();
  const [show, setShow]  = useState(false);
  const [tables, setTables] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [selectedShop, setSelectedShop] = useState(null);
  const [ searchQuery,setSearchQuery] = useState('');
  const [selectedItemCode, setSelectedItemCode] = useState(null);
  const [ isEdit,setIsEdit ] = useState(false);
  
  const [ isCreate,setCreate ] = useState(false);
  const [categories, setCategories] = useState([]);

  const [ loading, setLoading ] = useState(false);
  const [postLoading, setPostLoading] = useState(false);

  const [showGroupModal, setShowGroupModal] = useState(false);
   const [showSubGroupModal, setShowSubGroupModal] = useState(false);
  const [selectedGroupItems, setSelectedGroupItems] = useState([]);
   const [selectedSubGroupItems, setSelectedSubGroupItems] = useState([]);
  const [selectedFoodName, setSelectedFoodName] = useState('');
  const [editingGroupItem, setEditingGroupItem] = useState(null); // null means no editing, or holds the group item being edited
  const [newGroupItem, setNewGroupItem] = useState({ name: '', remarks: '', image: null }); // for new item form
  const [imagePreview, setImagePreview] = useState(null); // for image preview in form

const [showGroupFormModal, setShowGroupFormModal] = useState(false);
const [showGroupForm, setShowGroupForm] = useState(false);
const [showSubGroupForm, setShowSubGroupForm] = useState(false);
const [isEditingGroup, setIsEditingGroup] = useState(false);
const [isEditingSubGroup, setIsEditingSubGroup] = useState(false);
 const [selectedGroupName, setSelectedGroupName] = useState('');
 const [selectedGroupId, setSelectedGroupId] = useState(null);
const [groupFormData, setGroupFormData] = useState({
  product_id: "",
  name: "",
  image: null,
  remarks: "",
});
const [subGroupFormData, setSubGroupFormData] = useState({
  group_id: "",
  name: "",
  remarks: "",
});


  const ItemCodeOptions = [

    { value: 'Burger', label: 'Burger' },
    { value: 'Briyani', label: 'Briyani' },
    { value: 'Breakfast', label: 'Breakfast' },
    // Add more options as needed
  ];
  const [selectedId, setSelectedId] = useState(null); // Track selected ID if needed

  const handleNavigateAndFetch = (id) => {
    // Save the ID if needed, or directly use it for the GET request on the new page
    setSelectedId(id); // Optionally save it to state if you need it on the current page

    // Navigate to the new page
    history.push(`/variant-food-master/${id}`); // Navigate and pass the ID in the URL
  };
  const ItemCategoryOptions = [

    { value: 'semi burger', label: 'semi burge' },
    { value: 'small burger', label: 'small burger' },
    { value: 'large burger', label: 'large burger' },
    // Add more options as needed
  ];

  const [EmployeeD, setEmployeeD] = useState({});
  const [formData, setFormData] = useState({
    category_id: "",
    category_name: "",
    sub_category_id: "",
    sub_category_name: "",
    food_name: "",
    food_code: "",
    description: "",
    price: "",
    food_image: '',
    uom:'',
    is_additional_notes: 0, // <-- Add this
    is_billing: 0,
    group_items: [
    { name: '', remarks: '', image: null, sub_groups: []  } // You can initialize more if needed
  ],
    is_group: 0,
    is_sub_group: 0,
    organic_price: "", // If you're using this field
  });
const [updateformData, setUpdateFormData] = useState({
  category_id: "",
    category_name: "",
    sub_category_id: "",
    sub_category_name: "",
    food_name: "",
    food_code: "",
    description: "",
    price: "",
    food_image: '',
    uom:'',
    shop_id:'',
    is_additional_notes:0,
    is_group: 0, 
    organic_price: "",
      is_billing: 0
});

console.log(formData)

const [currentPage, setCurrentPage] = useState(1);
const [itemsPerPage] = useState(10); // Number of items per page
const [searchTerm, setSearchTerm] = useState('');
const [showModal, setShowModal] = useState(false);
const [uom, setUom] = useState('');
const [selectedFoodId, setSelectedFoodId] = useState(null);
const [isOpenQtyDelete, setIsOpenQtyDelete] = useState(false);
const [itemIdToDelete, setItemIdToDelete] = useState(null);

// Filtering tables based on search
const filteredTables = tables.filter((item) => {
  return (
    item.food_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.category_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.sub_category_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.food_code.toLowerCase().includes(searchTerm.toLowerCase()) ||
    String(item.price).toLowerCase().includes(searchTerm.toLowerCase()) ||
    String(item.uom).toLowerCase().includes(searchTerm.toLowerCase()) 


  );
});

// Pagination logic
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentItems = filteredTables.slice(indexOfFirstItem, indexOfLastItem);
const totalItems = filteredTables.length;

const handleSearchInput = (event) => {
  setSearchTerm(event.target.value);
  setCurrentPage(1); // Reset to the first page when search changes
};

const handlePageChange = (pageNumber) => {
  setCurrentPage(pageNumber);
};

  
//change the shop
const handleShopSelectChange = (selectedItem) => {
  console.log("selectedItem",selectedItem)
  const role = selectedItem.value;
  setSelectedShop(role);
  fetchTables(role);
};
const handleSwitchToggle=()=> {
  // Toggle the switch state
  const newStatus = !this.state.imageStatus;
  this.setState({ imageStatus: newStatus });
  // Update localStorage
  localStorage.setItem('image_status', newStatus ? '1' : '0');
  console.log("imagestatus",localStorage.getItem('image_status'));
};
    useEffect(() => {
        fetchTables();
        fetchSubCategory();
        fetchCategories();
      }, []);

      
      const fetchCategories = async () => {
        setLoading(true);
        const shopId = localStorage.getItem('ShopId')
        try {
           const token = localStorage.getItem('Token')

           const response = await axios.get(`${var_api}category-master/get/${shopId}`,{
            headers:{
              Authorization:`${token}`
            }
           });
           setLoading(false);
           console.log("response",response)
          const user =response.data;
          setCategories(user);
          
        } catch (error) {
          setLoading(false);
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error fetching data:", error);
          }
        }
      };



      const fetchSubCategory = async () => {
        setLoading(true);
        const shopId = localStorage.getItem('ShopId')
        try {
           const token = localStorage.getItem('Token')

           const response = await axios.get(`${var_api}sub-category-master/get/${shopId}`,{
            headers:{
              Authorization:`${token}`
            }
           });
           setLoading(false);
           console.log("response",response)
          const user =response.data;
          setSubCategory(user);
          
        } catch (error) {
          setLoading(false);
          if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error fetching data:", error);
      }
        }
      };



      const fetchTables = async () => {
        setLoading(true);
        const shopId = localStorage.getItem('ShopId')
        try {
           const token = localStorage.getItem('Token')

           const response = await axios.get(`${var_api}food-master/get/${shopId}`,{
            headers:{
              Authorization:`${token}`
            }
           });
           setLoading(false);
           console.log("response",response)
          const user =response.data;
          setTables(user);
          
        } catch (error) {
          setLoading(false);
           if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error fetching data:", error);
      }
        }
      };
      

   

 
      



 // Function to handle checkbox change
//  const handleCheckboxChange = (index) => {
//   const updatedShops = [...formData.shops];
//   const selectedShop = updatedShops[index];
  
//   // Toggle is_active property
//   updatedShops[index] = {
//       ...selectedShop,
//       is_active: selectedShop.is_active === 1 ? 0 : 1
//   };

//   setFormData(prevState => ({
//       ...prevState,
//       shops: updatedShops
//   }));
// };
const handleCheckboxChange = (e) => {
  const isChecked = e.target.checked;
  setFormData((prev) => ({
    ...prev,
    is_group: isChecked,
    group_items: isChecked
      ? [{ name: '', remarks: '', image: null }] // initialize when checked
      : [] // optional: reset if unchecked
  }));
};



  // Function to capitalize the first letter of a string
  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
   };
  
   const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  
  const handleImageChange = (e) => {
    setFormData({ ...formData, food_image: e.target.files[0] });
  };
  const handleImageChanges = (e) => {
    setUpdateFormData({ ...updateformData, food_image: e.target.files[0] });
  };
  const handleCodeSelectChange = (selectedOption, actionMeta) => {
    const { name } = actionMeta;
    setFormData({ ...formData, [name]: selectedOption.value });
  };
  const resetForm = () => {
    setFormData({
      category_id: "",
      category_name: "",
      sub_category_id: "",
      sub_category_name: "",
      food_name: "",
      food_code: "",
      description: "",
      price: "",
      food_image: '',
      is_billing:0,
      is_additional_notes:0,
      is_group:0
    });
  
   
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    const shop_id=localStorage.getItem('ShopId');
    const payload = new FormData();

    // Append fields to FormData
    payload.append("shop_id", shop_id); // Assuming this is static for now
    payload.append("category_id", formData.category_id);
    payload.append("category_name", formData.category_name);
    payload.append("sub_category_id", formData.sub_category_id);
    payload.append("sub_category_name", formData.sub_category_name);
    payload.append("food_name", formData.food_name);
    payload.append("food_code", formData.food_code);
    payload.append("description", formData.description);
    payload.append("price", formData.price);
    payload.append("uom", formData.uom);
    payload.append("is_additional_notes", formData.is_additional_notes);
    payload.append("is_active", 1); // Static value for now
    payload.append("is_group", formData.is_group ? 1 : 0 || 0);
    payload.append("organic_price", formData.organic_price || 0);
    payload.append("is_billing", formData.is_billing || 0);

    // Check if food_image exists and append it to FormData
    if (formData.food_image) {
      payload.append("food_image", formData.food_image);
    }

     // Group Data
  const groupFoods = (formData.group_items || []).map((groupItem) => {
    // If image is selected, include its name
    if (groupItem.image) {
      payload.append("group_image", groupItem.image, groupItem.image.name);
    }

    return {
      name: groupItem.name,
      remarks: groupItem.remarks,
      image: groupItem.image?.name || '',
      sub_groups: groupItem.sub_groups || [],
    };
  });

  payload.append("groupFoods", JSON.stringify(groupFoods));

  
    // Set the loading state while submitting
    setPostLoading(true);
  
    try {
      // Retrieve the token from localStorage
      const token = localStorage.getItem('Token');
  
      // Send the FormData with Axios
      const response = await axios.post(`${var_api}food-master/post`, payload, {
        headers: {
          "Content-Type": "multipart/form-data", // Set content type for file upload
          Authorization: `${token}`, // Include the authorization token
        },
      });
      console.log("Response:", response.data);
      Swal.fire({
        icon: "success",
        title: "Food Created Successfully!",
        confirmButtonText: "OK",
      });
      setCreate(false);
      fetchTables();
      resetForm();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: `${error.response.data.error}`,
        confirmButtonText: "OK",
      });
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error submitting data:", error);
      }
    } finally {
      setPostLoading(false);
    }
  };


      const handleSelectChange = (selectedOption, { name, labelName }) => {
        setFormData((prev) => ({
          ...prev,
          [name]: selectedOption.value,
          [labelName]: selectedOption.label,
        }));
      };

      const handleUpdateSelectChange = (selectedOption, { name, labelName }) => {
        setUpdateFormData((prev) => ({
          ...prev,
          [name]: selectedOption.value,
          [labelName]: selectedOption.label,
        }));
      };
    
    

     //delete method for remove UOM
   const handleDeleteEmployeee = (id) => {
    setShow(true);
    setEmployeeD(id);
    }


    //delete the employeee
    const handleDelete = () => {
      const token = localStorage.getItem("Token"); // Adjust the key based on where the token is stored
    
      axios
        .delete(`${var_api}food-master/delete/${EmployeeD}`, {
          headers: {
            Authorization: `${token}`, // Pass the token in the Authorization header
          },
        })
        .then((response) => {
          if (response.status === 200) {
            fetchTables();
            setShow(false);
            Swal.fire("Success", "Food Removed Successfully!", "success");
            // Perform any other actions you need on success
          } else if (response.status === 404) {
            console.log("Table not found");
            Swal.fire("Error", "Food not found!", "error");
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error deleting data:", error);
          }
          Swal.fire("Error", "Failed to Remove Food!", "error");
          // Handle the error as needed
        });
    };    


    //Function for open the update modal
    const handleUpdateEmployee = (data) =>{
      setIsEdit(true);
    //   console.log("data",data)
      setUpdateFormData({
        category_id: data.category_id,
        category_name: data.category_name,
        sub_category_id: data.sub_category_id,
        sub_category_name: data.sub_category_name,
        food_name: data.food_name,
        food_code: data.food_code,
        description: data.description,
        price: data.price,
        food_image: data.food_image,
        uom:data.uom,
        id:data.id,
        is_active:data.is_active,
        shop_id:data.shop_id,
        is_additional_notes: data.is_additional_notes,
        is_group: data.is_group,
        is_billing: data.is_billing,
        organic_price: data.organic_price
      })
    }
    const handleCreateEmployee = () =>{
      setCreate(true);
      setFormData({});
    }
    //Function for update text field onchange
const handleInputUpdateChange = (e) => {
  const { name, value } = e.target;
  setUpdateFormData({ ...updateformData, [name]: value });
};

const handleUpdateSubmit = async (e) => {
  e.preventDefault();  
  console.log("updateformData",updateformData);
 
  

  const formDataToSend = new FormData();

  formDataToSend.append('category_id', updateformData.category_id);
  formDataToSend.append('category_name', updateformData.category_name);
  formDataToSend.append('sub_category_id', updateformData.sub_category_id);
  formDataToSend.append('sub_category_name', updateformData.sub_category_name);
  formDataToSend.append('food_name', updateformData.food_name);
  formDataToSend.append('food_code', updateformData.food_code); 
  formDataToSend.append('description', updateformData.description);
  formDataToSend.append('price', updateformData.price);
  formDataToSend.append('organic_price', updateformData.organic_price);
  formDataToSend.append('food_image', updateformData.food_image); 
  formDataToSend.append('uom', updateformData.uom);
  formDataToSend.append('shop_id', updateformData.shop_id);
  formDataToSend.append('is_active', updateformData.is_active);
  formDataToSend.append('is_additional_notes', updateformData.is_additional_notes);
  formDataToSend.append('is_billing', updateformData.is_billing);
  formDataToSend.append('is_group', updateformData.is_group);

   try {
    const token=localStorage.getItem('Token');
    const response = await fetch(`${var_api}food-master/put/${updateformData.id}`, {
      method: 'PUT',
    body: formDataToSend,
    headers:{
      Authorization:`${token}`
    }
  }
);
    if(response.status == 200){
      fetchTables();
      setIsEdit(false);
      Swal.fire({
        title: 'Success',
        text: 'Food Updated Successfully.',
        icon: 'success',
        confirmButtonColor: '#007500', // Set the custom color for the Confirm button
      });
      
      const data = await response.json();
      console.log('Registration successful!',data);
   
    }else {
      console.error('Failed to Update Food:', response.statusText);
      // Handle error, e.g., show an error message to the user
      Swal.fire({
        title: 'error',
        text: 'Failed to Update Food...Please Try Again!',
        icon: 'error',
        confirmButtonColor: '#007500', // Set the custom color for the Confirm button
      });
    }
    
    // Handle success scenario as needed
  } catch (error) {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('Token'); // Clear the invalid token
      history.push('/')// Redirect to the Sign-In page
    } else {
      console.error("Error updating data:", error);
    }
      // Handle error scenario as needed
    }
  };



  const handleToggle = (isChecked, item) => {
    // Create FormData
    const formDataToSend = new FormData();
    formDataToSend.append('category_id', item.category_id);
  formDataToSend.append('category_name', item.category_name);
  formDataToSend.append('sub_category_id', item.sub_category_id);
  formDataToSend.append('sub_category_name', item.sub_category_name);
  formDataToSend.append('food_name', item.food_name);
  formDataToSend.append('food_code', item.food_code); 

  formDataToSend.append('description', item.description);
  formDataToSend.append('price', item.price);
  formDataToSend.append('food_image', item.food_image); 
  formDataToSend.append('uom', item.uom);
  formDataToSend.append('shop_id', item.shop_id);
  formDataToSend.append('is_additional_notes', item.is_additional_notes);
  formDataToSend.append("is_active", isChecked ? 1 : 0);
  
    const token = localStorage.getItem("Token");
  
    axios
      .put(`${var_api}food-master/put/${item.id}`, formDataToSend, {
        headers: {
          Authorization: `${token}`,
          "Content-Type": "multipart/form-data", // FormData requires this Content-Type
        },
      })
      .then((response) => {
        if (response.status === 200) {
          Swal.fire("Success", "Status updated successfully!", "success");
          fetchTables();
        } else {
          Swal.fire("Error", "Failed to update  status!", "error");
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('Token'); // Clear the invalid token
          history.push('/')// Redirect to the Sign-In page
        } else {
          console.error("Error updating data:", error);
        }
        Swal.fire("Error", `${error.response?.data?.error || "Unexpected error occurred"}`, "error");
      });
  };


  const handleQuantityChange = (foodId, quantityId) => {
    // Update the selected quantity for the given food item
    const updatedItems = currentItems.map((item) =>
      item.id === foodId ? { ...item, selectedQuantity: quantityId } : item
    );
    // setCurrentItems(updatedItems);
  };
  
  
  const handleOpenModal = (foodId) => {
    setSelectedFoodId(foodId);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setUom('');
  };


  const handleUomSubmit = async () => {
    if (!uom) {
      alert('Please enter a valid quantity (UOM).');
      return;
    }

    try {
      const token = localStorage.getItem('Token'); // Assuming the token is stored in localStorage
      const response = await axios.post(
        `${var_api}quantity-master/post`,
        { food_id: selectedFoodId, quantity: uom },
        { headers: { Authorization: token } }
      );
      Swal.fire({
        title: 'Success',
        text: 'Quantity added successfully!',
        icon: 'success',
        confirmButtonColor: '#007500', // Set the custom color for the Confirm button
      });
     
      console.log('API Response:', response.data);
      handleCloseModal();
      fetchTables();
    } catch (error) {
      console.error('Error submitting UOM:', error);
      Swal.fire({
        title: 'Error',
        text: 'Failed to add quantity. Please try again.',
        icon: 'Eroor',
        confirmButtonColor: '#007500', // Set the custom color for the Confirm button
      });
    }
  };

  
  const handleDeleteQuantity = (foodId, qty_id, qty) => {
    // Logic to delete the selected quantity
    console.log(`Delete quantity for food ID: ${foodId}`);
    setIsOpenQtyDelete(true);
    setItemIdToDelete({
      foodId: foodId,
      qty: qty,
      qty_id: qty_id
    })
  };


  // Close the modal
  const handleCloseQty = () => {
    setIsOpenQtyDelete(false);
  };



   // Handle Confirm Button Click (send API request)
   const handleConfirmDelete = async () => {
    try {
      const token = localStorage.getItem('Token'); // assuming token is stored in localStorage
      if (!token) {
        alert('You must be logged in to delete.');
        return;
      }

      const response = await axios.delete(`${var_api}quantity-master/delete/${itemIdToDelete.qty_id}`, {
        headers: { 'Authorization': `${token}` }
      });

      // Handle the response after deletion
      if (response.data.message === 'Quantity deleted successfully') {
        Swal.fire({
          title: 'Success',
          text: 'Quantity deleted successfully!',
          icon: 'success',
          confirmButtonColor: '#007500', // Set the custom color for the Confirm button
        });
        setIsOpenQtyDelete(false);
        fetchTables();
        // Optionally update your state to reflect the deletion in the UI (e.g., remove the deleted item)
      }
    } catch (error) {
      console.error('Error deleting item:', error);
      Swal.fire({
        title: 'Error',
        text: 'There was an error deleting the item.',
        icon: 'Eroor',
        confirmButtonColor: '#007500', // Set the custom color for the Confirm button
      });
     
    }
  };


  // Add group item to formData
const handleAddGroupItem = () => {
  setFormData((prev) => ({
    ...prev,
    group_items: [...(prev.group_items || []), { name: '', remarks: '', image: null }],
  }));
};

// Update text fields (like name, remarks)
const handleGroupItemChange = (field, value) => {
  const updatedItems = [...formData.group_items];
  updatedItems[0][field] = value;
  setFormData({ ...formData, group_items: updatedItems });
};

// Update image
const handleGroupImageChange = (file) => {
  const updatedItems = [...formData.group_items];
  updatedItems[0].image = file;
  setFormData({ ...formData, group_items: updatedItems });
};



const handleSubGroupChange = (field, value) => {
  const updatedGroupItems = formData.group_items?.length > 0 
    ? [...formData.group_items]
    : [{ name: '', remarks: '', image: null, sub_groups: [] }];

  // Make sure sub_groups is initialized
  if (!updatedGroupItems[0].sub_groups) {
    updatedGroupItems[0].sub_groups = [];
  }

  const existingSubGroup = updatedGroupItems[0].sub_groups[0] || {};

  updatedGroupItems[0].sub_groups[0] = {
    ...existingSubGroup,
    [field]: value
  };

  setFormData({
    ...formData,
    group_items: updatedGroupItems
  });
};


const handleCreateGroupItem = () => {
  setGroupFormData({ name: "", remarks: "", image: null });
  setIsEditingGroup(false);
  setShowGroupForm(true);
};


const handleCreateSubGroupItem = () => {
  setSubGroupFormData({ name: "", remarks: ""});
  setIsEditingSubGroup(false);
  setShowSubGroupForm(true);
};

const handleEditGroupItem = (groupItem) => {
  setIsEditingGroup(true);
  setGroupFormData({
    id: groupItem.id,
    product_id: groupItem.product_id,
    name: groupItem.name,
    image: null, // set to null; image editing optional
    remarks: groupItem.remarks,
  });
  setShowGroupForm(true);
};

const handleEditSbGroupItem = (groupItem) => {
  setIsEditingSubGroup(true);
  console.log("bas",groupItem)
  setSubGroupFormData({
    id: groupItem.id,
    group_id_id: selectedGroupId,
    name: groupItem.name,
    remarks: groupItem.remarks,
  });
  setShowSubGroupForm(true);
};

const handleGroupFormSubmit = async () => {
    const token = localStorage.getItem('Token')

  const formData = new FormData();
  formData.append("name", groupFormData.name);
  formData.append("remarks", groupFormData.remarks);
  formData.append("product_id", selectedFoodId); // save this during group modal open
  if (groupFormData.image) {
    formData.append("image", groupFormData.image);
  }

  const config = {
    headers: {
      Authorization: `${token}`,
    },
  };

  try {
    if (isEditingGroup) {
      await axios.put(`${var_api}group-foods/put/${groupFormData.id}`, formData, config);
    } else {
      await axios.post(`${var_api}group-foods/post`, formData, config);
    }
    alert(`Group Item ${isEditingGroup ? "updated" : "created"} successfully`);
    setShowGroupFormModal(false);
    setShowGroupForm(false);
    setIsEditingGroup(false);
    fetchTables(); // re-fetch group items
    if (isEditingGroup) {
  // Update existing group item in state
  setSelectedGroupItems(prev =>
    prev.map(item =>
      item.id === groupFormData.id
        ? { ...item, name: groupFormData.name, remarks: groupFormData.remarks, image: groupFormData.image }
        : item
    )
  );
} else {
  // Append new group item (this assumes backend returns the new product_id)
  const newItem = {
    product_id: groupFormData.product_id,
    name: groupFormData.name,
    remarks: groupFormData.remarks,
    image: groupFormData.image
  };
  setSelectedGroupItems(prev => [...prev, newItem]);
}

  } catch (error) {
    console.error("Error submitting group item", error);
    alert("Failed to save group item");
  }
};


//creating sub group
const handleSubGroupFormSubmit = async () => {
    const token = localStorage.getItem('Token')

  const data = {
    name: subGroupFormData.name,
    remarks: subGroupFormData.remarks,
    group_id: selectedGroupId, // Save this during group modal open
  };

  const config = {
    headers: {
      Authorization: `${token}`,
    },
  };

  try {
    if (isEditingSubGroup) {
      await axios.put(`${var_api}sub-group-foods/put/${subGroupFormData.id}`, data, config);
    } else {
      await axios.post(`${var_api}sub-group-foods/post`, data, config);
    }
    alert(`Group Item ${isEditingSubGroup ? "updated" : "created"} successfully`);
   
    setShowSubGroupForm(false);
    setIsEditingSubGroup(false);
    fetchTables(); // re-fetch group items
    if (isEditingSubGroup) {
  // Update existing group item in state
  setSelectedSubGroupItems(prev =>
    prev.map(item =>
      item.id == subGroupFormData.id
        ? { ...item, name: subGroupFormData.name, remarks: subGroupFormData.remarks }
        : item
    )
  );
} else {
  // Append new group item (this assumes backend returns the new product_id)
  const newItem = {
    group_id: subGroupFormData.group_id,
    name: subGroupFormData.name,
    remarks: subGroupFormData.remarks,
  };
  setSelectedSubGroupItems(prev => [...prev, newItem]);
}

  } catch (error) {
    console.error("Error submitting group item", error);
    alert("Failed to save group item");
  }
};


const handleDeleteGroupItem = async (id) => {
  if (!window.confirm("Are you sure you want to delete this group item?")) return;

  const token = localStorage.getItem('Token');
  const config = {
    headers: {
      Authorization: `${token}`,
    },
  };

  try {
    await axios.delete(`${var_api}group-foods/delete/${id}`, config);
    alert("Deleted successfully");

    // Update group items in modal immediately
    setSelectedGroupItems((prevItems) => prevItems.filter((item) => item.id !== id));

    fetchTables();
  } catch (err) {
    console.error(err);
    alert("Failed to delete");
  }
};


const handleDeleteSubGroupItem = async (id) => {
  if (!window.confirm("Are you sure you want to delete this Sub group item?")) return;

  const token = localStorage.getItem('Token');
  const config = {
    headers: {
      Authorization: `${token}`,
    },
  };

  try {
    await axios.delete(`${var_api}sub-group-foods/delete/${id}`, config);
    alert("Deleted successfully");

    // Update group items in modal immediately
    setSelectedSubGroupItems((prevItems) => prevItems.filter((item) => item.id !== id));

    fetchTables();
  } catch (err) {
    console.error(err);
    alert("Failed to delete");
  }
};

    return(
      <>         
      <Layout>
        <div class="splitcsc">
          
      <div style={{border:"none",padding:"15px",width:"105%",minHeight:"630px",margin:"auto",borderRadius:"10px",backgroundColor:"white",boxShadow:" rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px"}}>
    
      <Button variant='dark'className='mb-4' onClick={handleCreateEmployee}  style={{fontSize:"14px",float:"right",borderRadius:"10px", marginLeft:"10px"}}>Create Food</Button>{' '}
      
      <div>
    
     
       <div class="row">
         <div class="col">
         <h4 className='ushefm'>FOOD MANAGEMENT</h4>
         </div>
         <div class="col">
         <input class="form-control" type="Search" placeholder="Search" id="example-search-input" 
      style={{width:"230px",borderRadius:"10px",border:"1px solid black",float:"right"}} onChange={handleSearchInput}/>
         </div>
        
       </div>
    <br/>
      <div className="table-container" style={{  maxHeight:"540px", overflowX: 'auto', overflowY: 'scroll' }}>
     <table class="table table-hover small-first-col" style={{border:"none",borderColor:"grey",width:"90%",margin:"auto"}}>
  <thead>
    <tr style={{fontWeight:"bolder"}}>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">S.No</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Category Name</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Sub Category Name</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Food Image</th>
       <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Food Name</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Description</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Food Code</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">UOM</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Regular price</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Organic price</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Has Notes</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Status</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Group Items</th>
      <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Action</th>
    </tr>
  </thead>
  {loading ? (
  <div className="loader-containeru">
    <div className="spinneru"></div>
  </div>
) : (
  <tbody className="body-half-screen">
    {currentItems?.length === 0 ? (
      <tr>
        <td colSpan="11" style={{ textAlign: 'center' }}>No Data Available</td>
      </tr>
    ) : (
      currentItems.map((item, index) => (
        <tr style={{ padding: "7px" }} key={index}>
          <th scope="row" style={{ textTransform: "capitalize", textAlign: "left" }}>
            {indexOfFirstItem + index + 1}
          </th>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>
            {item.category_name}
          </td>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>
            {item.sub_category_name}
          </td>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>
            <img
              src={`${image_api}/${item.food_image}`}
              alt="profile"
              width="55px"
              height="55px"
            />
          </td>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>
            {item.food_name}
          </td>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>
            {item.description}
          </td>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>
            {item.food_code}
          </td>
          <td style={{ textTransform: "capitalize", textAlign: "left" }}>{item.uom}</td>
          {/* <td style={{ textTransform: "capitalize", textAlign: "left" }}>
  <div className="dropdown">
    <button
      className="btn btn-light dropdown-toggle"
      type="button"
      id={`dropdownMenuButton-${item.id}`}
      data-bs-toggle="dropdown"
      aria-expanded="false"
      style={{ width: "100%", textAlign: "left" }}
    >
      {item.quantities.length > 0 ? item.quantities[0].quantityc : "No Quantities Available"}
    </button>
    <ul className="dropdown-menu" aria-labelledby={`dropdownMenuButton-${item.id}`} style={{padding:"15px"}}>
      {item.quantities.map((quantityObj, index) => (
        <li key={quantityObj.id} style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <span>{quantityObj.quantity}</span>
          <i
            className="bi bi-trash-fill"
            style={{ color: "red", cursor: "pointer", marginLeft: "10px" }}
            onClick={() => handleDeleteQuantity(item.id, quantityObj.id, quantityObj.quantity)}
          ></i>
        </li>
      ))}
    </ul>
  </div>
  <button
    className="btn btn-primary btn-sm"
    style={{ marginTop: "10px" }}
    onClick={() => handleOpenModal(item.id)}
  >
    Add Quantity
  </button>
</td> */}



          <td style={{ textTransform: "capitalize", textAlign: "left" }}>
            ₹{item.price.toFixed(2)}
          </td>
           <td style={{ textTransform: "capitalize", textAlign: "left" }}>
            ₹{item.organic_price.toFixed(2)}
          </td>

          <td style={{ textAlign: "left" }}>
  <span className={`badge ${item.is_additional_notes === 1 ? "bg-success" : "bg-secondary"}`}>
    {item.is_additional_notes == 1 ? "Yes" : "No"}
  </span>
</td>
          <td style={{ textAlign: "left" }}>
            <div className="form-check form-switch" style={{ display: "flex", justifyContent: "left" }}>
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              checked={item.is_active === 1} // Checkbox is checked if is_active is 1
              onChange={(e) => handleToggle(e.target.checked, item)}
            />
            </div>
          </td>

         <td style={{ textAlign: "left" }}>
  <span
    className={`badge ${item.groups ? "bg-light text-success" : "bg-light text-secondary"}`}
    style={{
      border: item.groups ? "2px solid green" : "2px dashed gray",
      borderRadius: "999px",
      padding: "5px 10px",
      fontWeight: "500"
    }}
     onClick={() => {
      setSelectedGroupItems(item.groups || []);
      setSelectedFoodName(item.food_name);
      setShowGroupModal(true);
      setSelectedFoodId(item.id);
    }}
  >
    {item?.groups?.length} Group Items
  </span>
</td>


         
          <td style={{ textAlign: "left" }}>
            <i
              className="bi bi-pencil-square"
              onClick={()=> handleUpdateEmployee(item)}
              style={{ fontSize: "20px", color: "rgb(9, 97, 9)" }}
            ></i>{' '}
            <i
              className="bi bi-trash"
              onClick={()=> handleDeleteEmployeee(item.id)}
              style={{ fontSize: "21px", color: "rgb(175, 2, 2)" }}
            ></i>
<i className="bi bi-arrow-right-square-fill" onClick={() => handleNavigateAndFetch(item.id)} style={{ fontSize: "21px", color: "green" }}></i>
</td>
        </tr>
      ))
    )}
  </tbody>
)}

</table>
<Pagination
        activePage={currentPage}
        itemsCountPerPage={itemsPerPage}
        totalItemsCount={totalItems}
        pageRangeDisplayed={5}
        onChange={handlePageChange}
        itemClass="page-item"
        linkClass="page-link"
        innerClass="pagination justify-content-end"
        activeClass="active-pagination"
      />

      </div>
      

</div>
        </div>
      
      </div>

      <Modal show={showGroupModal} onHide={()=>setShowGroupModal(false)} size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>Group Items for <strong style={{color:"red"}}>{selectedFoodName}</strong></Modal.Title>
      </Modal.Header>
      <Modal.Body>
         <div >
           <div className="d-flex justify-content-between align-items-center mb-3">
      {/* <h5 className="mb-0">Group Items</h5> */}
      <Button variant="primary" size="sm" onClick={handleCreateGroupItem}>
        + Add Group Item
      </Button>
    </div>

    {/* Form to Add/Edit */}
    {showGroupForm && (
      <form className="border p-3 rounded mb-4 bg-light">
        <div className="row">
          <div className="col-md-4">
            <input
              type="text"
              placeholder="Name"
              className="form-control"
              value={groupFormData.name}
              onChange={(e) =>
                setGroupFormData({ ...groupFormData, name: e.target.value })
              }
            />
          </div>
          <div className="col-md-4">
            <input
              type="text"
              placeholder="Remarks"
              className="form-control"
              value={groupFormData.remarks}
              onChange={(e) =>
                setGroupFormData({ ...groupFormData, remarks: e.target.value })
              }
            />
          </div>
          <div className="col-md-4">
            <input
              type="file"
              className="form-control"
              onChange={(e) =>
                setGroupFormData({ ...groupFormData, image: e.target.files[0] })
              }
            />
          </div>
        </div>
        <div className="mt-3 text-end">
          <Button
            variant="success"
            size="sm"
            onClick={handleGroupFormSubmit}
            className="me-2"
          >
            {isEditingGroup ? "Update" : "Create"}
          </Button>
          <Button
            variant="secondary"
            size="sm"
            onClick={() => {
              setShowGroupForm(false);
              setIsEditingGroup(false);
              setGroupFormData({ name: "", remarks: "", image: null });
            }}
          >
            Cancel
          </Button>
        </div>
      </form>
    )}
          {selectedGroupItems?.length === 0 ? (
            <p>No Group Items Available</p>
          ) : (
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Remarks</th>
                  <th>Sub Group Items</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {selectedGroupItems.map((group, index) => (
                  <tr key={group.product_id || index}>
                    <td>{index + 1}</td>
                    <td>
                      {
                        group.image &&
                        <span>
                        <img src={`${image_api}/${group.image}`} width="50" height="50" alt="group" />
                      </span>
                      }{" "}{group.name}
                    </td>
                    <td>{group.remarks}</td>
                    <td>
                      <span
    className={`badge ${group.sub_groups ? "bg-light text-success" : "bg-light text-secondary"}`}
    style={{
      border: group.sub_groups ? "2px solid green" : "2px dashed gray",
      borderRadius: "999px",
      padding: "5px 10px",
      fontWeight: "500"
    }}
     onClick={() => {
      setSelectedSubGroupItems(group.sub_groups || []);
      setSelectedGroupName(group.name);
      setShowSubGroupModal(true);
      setSelectedGroupId(group.id);
    }}
  >
    {group.sub_groups?.length} Sub Group Items
  </span>
                    </td>
                     <td>
        <i
          className="bi bi-pencil-square text-success"
          style={{ cursor: "pointer", marginRight: "10px" }}
          onClick={() => handleEditGroupItem(group)}
        ></i>
        <i
          className="bi bi-trash text-danger"
          style={{ cursor: "pointer" }}
          onClick={() => handleDeleteGroupItem(group.id)}
        ></i>
      </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowGroupModal(false)}> Cancel</Button>
      </Modal.Footer>
    </Modal>


    <Modal show={showSubGroupModal} onHide={()=>setShowSubGroupModal(false)} size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>Sub Group Items for <strong style={{color:"red"}}>{selectedGroupName}</strong></Modal.Title>
      </Modal.Header>
      <Modal.Body>
         <div >
           <div className="d-flex justify-content-between align-items-center mb-3">
      {/* <h5 className="mb-0">Group Items</h5> */}
      <Button variant="primary" size="sm" onClick={handleCreateSubGroupItem}>
        + Add Sub Group Item
      </Button>
    </div>

    {/* Form to Add/Edit */}
    {showSubGroupForm && (
      <form className="border p-3 rounded mb-4 bg-light">
        <div className="row">
          <div className="col-md-4">
            <input
              type="text"
              placeholder="Name"
              className="form-control"
              value={subGroupFormData.name}
              onChange={(e) =>
                setSubGroupFormData({ ...subGroupFormData, name: e.target.value })
              }
            />
          </div>
          <div className="col-md-4">
            <input
              type="text"
              placeholder="Remarks"
              className="form-control"
              value={subGroupFormData.remarks}
              onChange={(e) =>
                setSubGroupFormData({ ...subGroupFormData, remarks: e.target.value })
              }
            />
          </div>
        </div>
        <div className="mt-3 text-end">
          <Button
            variant="success"
            size="sm"
            onClick={handleSubGroupFormSubmit}
            className="me-2"
          >
            {isEditingSubGroup ? "Update" : "Create"}
          </Button>
          <Button
            variant="secondary"
            size="sm"
            onClick={() => {
              setShowSubGroupForm(false);
              setIsEditingSubGroup(false);
              setSubGroupFormData({ name: "", remarks: ""});
            }}
          >
            Cancel
          </Button>
        </div>
      </form>
    )}
          {selectedSubGroupItems?.length === 0 ? (
            <p>No Sub Group Items Available</p>
          ) : (
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Remarks</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {selectedSubGroupItems.map((group, index) => (
                  <tr key={group.id || index}>
                    <td>{index + 1}</td>
                    <td>
                     {group.name}
                    </td>
                    <td>{group.remarks}</td>
                    
                     <td>
        <i
          className="bi bi-pencil-square text-success"
          style={{ cursor: "pointer", marginRight: "10px" }}
          onClick={() => handleEditSbGroupItem(group)}
        ></i>
        <i
          className="bi bi-trash text-danger"
          style={{ cursor: "pointer" }}
          onClick={() => handleDeleteSubGroupItem(group.id)}
        ></i>
      </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowSubGroupModal(false)}> Cancel</Button>
      </Modal.Footer>
    </Modal>



      <Modal show={isOpenQtyDelete} onHide={handleCloseQty}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Deletion</Modal.Title>
      </Modal.Header>
      <Modal.Body>Are you sure you want to delete this {itemIdToDelete && itemIdToDelete.qty}?</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseQty}>Cancel</Button>
        <Button variant="danger" onClick={handleConfirmDelete}>Delete</Button>
      </Modal.Footer>
    </Modal>


      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Quantity</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Enter UOM:</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter quantity"
                value={uom}
                onChange={(e) => setUom(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary" onClick={handleUomSubmit}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={show}
        onHide={()=>setShow(false)}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
      >
        <Modal.Header style={{padding:"3px", backgroundColor:"green"}}>
          <Modal.Title style={{ fontSize:"20px"}}></Modal.Title>
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px"}}>
         {/* <h4 style={{fontFamily:"monospace",fontWeight:"bolder",textAlign:"center"}}>CONFIRM !</h4> */}
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure want to Delete Food Name 
          <span style={{color:"red",textTransform:"uppercase"}}> {EmployeeD.employee_name}</span> ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={()=>setShow(false)}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={handleDelete}>
            Confirm
          </Button>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseConfirmation}>
            Close
          </Button>
        </Modal.Footer> */}
      </Modal>

      <Modal
        show={isEdit}
        onHide={()=>setIsEdit(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> Update Food </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form className="py-2" onSubmit={handleUpdateSubmit}>
      <div className="row mb-2">
        <div className="col">
          <label htmlFor="category" style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>
            Select Category
          </label>
          <Select
            options={categories.map((category) => ({
              label: category.category_name,
              value: category.id,
            }))}
            value={{ value: updateformData.category_id, label: updateformData.category_name }}
            placeholder="Select Category"
            onChange={(selectedOption) =>
              handleUpdateSelectChange(selectedOption, { name: "category_id", labelName: "category_name" })
            }
            isSearchable={true}
            styles={{
              control: (provided) => ({
                ...provided,
                borderRadius: "10px",
              }),
            }}
          />
        </div>
        <div className="col">
          <label htmlFor="subCategory" style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>
            Select Sub Category
          </label>
          <Select
            options={subCategory.map((subcategory) => ({
              label: subcategory.sub_category_name,
              value: subcategory.id,
            }))}
            value={{ value: updateformData.sub_category_id, label: updateformData.sub_category_name }}

            placeholder="Select Sub Category"
            onChange={(selectedOption) =>
              handleUpdateSelectChange(selectedOption, { name: "sub_category_id", labelName: "sub_category_name" })
            }
            isSearchable={true}
            styles={{
              control: (provided) => ({
                ...provided,
                borderRadius: "10px",
              }),
            }}
          />
        </div>
      </div>
      <br/>
      {/* Other Input Fields */}
      <div className="row mb-4">
        <div className="col">
          <label htmlFor="food_name"  style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>Food Name</label>
          <input
            type="text"
            className="form-control"
            name="food_name"
            placeholder="Food Name"
            value={updateformData.food_name}
            onChange={handleInputUpdateChange}
            required
          />
        </div>
        <div className="col">
          <label htmlFor="food_code"  style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>Food Code</label>
          <input
            type="text"
            className="form-control"
            name="food_code"
            placeholder="Food Code"
            value={updateformData.food_code}
            onChange={handleInputUpdateChange}
            required
          />
        </div>
      </div>

      <div className="row mb-4">
        <div className="col">
          <label htmlFor="description"  style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>Food Description</label>
          <input
            type="text"
            className="form-control"
            name="description"
            placeholder="Food Description"
            value={updateformData.description}
            onChange={handleInputUpdateChange}
            required
          />
        </div>
        <div className="col">
           <label htmlFor="uom"  style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>Food UOM</label>
          <input
            type="text"
            className="form-control"
            name="uom"
            placeholder="Food uom"
            value={updateformData.uom}
            onChange={handleInputUpdateChange}
            required
          />
        </div>
      </div>

      <div className="row mb-2">
        <div className="col">
          <label htmlFor="price"  style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>Regular Price</label>
          <input
            type="number"
            className="form-control"
            name="price"
            placeholder="Food Price"
            value={updateformData.price}
            onChange={handleInputUpdateChange}
            required
            min="0.1"
            step="0.1"
          />
        </div>
        <div className='col'>
       <label htmlFor="organic_price"  style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>Organic Price</label>
          <input
            type="number"
            className="form-control"
            name="organic_price"
            placeholder="Organic Price"
            value={updateformData.organic_price}
            onChange={handleInputUpdateChange}
            required
            min="0.1"
            step="0.1"
          />
        </div>
      </div>

      <div className='row mb-4'>
        <div className='col'>
 <label htmlFor="food_image"  style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>Food Image</label>
          <input 
  type="file" 
  className="form-control" 
  id="formFile" 
  onChange={handleImageChanges} 
  name="food_image" 
  style={{borderRadius: "10px"}}
/>
        </div>
        <div className='col'>
           <div className="d-flex gap-3 mt-3">
            <div className="form-check mb-3">
  <input
    className="form-check-input"
    type="checkbox"
    id="is_additional_notes_update"
    name="is_additional_notes"
    checked={updateformData.is_additional_notes === 1}
    onChange={(e) =>
      setUpdateFormData({
        ...updateformData,
        is_additional_notes: e.target.checked ? 1 : 0,
      })
    }
  />
  <label className="form-check-label" htmlFor="is_additional_notes_update" style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>
    Is Additional Notes
  </label>
</div>

 <div className="form-check mb-3">
  <input
    className="form-check-input"
    type="checkbox"
    id="is_group_update"
    name="is_group_notes"
    checked={updateformData.is_group === 1}
    onChange={(e) =>
      setUpdateFormData({
        ...updateformData,
        is_group: e.target.checked ? 1 : 0,
      })
    }
  />
  <label className="form-check-label" htmlFor="is_additional_notes_update" style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>
    Is Group
  </label>
</div>

 <div className="form-check mb-3">
  <input
    className="form-check-input"
    type="checkbox"
    id="is_billing_update"
    name="is_billing"
    checked={updateformData.is_billing === 1}
    onChange={(e) =>
      setUpdateFormData({
        ...updateformData,
        is_billing: e.target.checked ? 1 : 0,
      })
    }
  />
  <label className="form-check-label" htmlFor="is_billing_update" style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>
    Is Billing
  </label>
</div>
           </div>
        </div>
      </div>

      
      <br />
      {postLoading ? (
          <span>Loading...</span>
        ) : (
          <button type="submit" className="btn btn-success" style={{ borderRadius: "10px",float:"right",marginRight:"5px", marginTop:"10px" }}>
            Update
          </button>
        )}
    </form>
    <button className="btn btn-danger" onClick={()=>setIsEdit(false)} style={{borderRadius:"10px",float:"right",marginRight:"5px"}}>Cancel</button>
        </Modal.Body>
      </Modal> 

      <Modal
        show={isCreate}
        onHide={()=>setCreate(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> Create Food Item</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form className="py-2" onSubmit={handleSubmit}>
      <div className="row mb-2">
        <div className="col">
          <label htmlFor="category" style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>
            Select Category
          </label>
          <Select
            options={categories.map((category) => ({
              label: category.category_name,
              value: category.id,
            }))}
            placeholder="Select Category"
            onChange={(selectedOption) =>
              handleSelectChange(selectedOption, { name: "category_id", labelName: "category_name" })
            }
            isSearchable={true}
            styles={{
              control: (provided) => ({
                ...provided,
                borderRadius: "10px",
              }),
            }}
          />
        </div>
        <div className="col">
          <label htmlFor="subCategory" style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>
            Select Sub Category
          </label>
          <Select
            options={subCategory.map((subcategory) => ({
              label: subcategory.sub_category_name,
              value: subcategory.id,
            }))}
            placeholder="Select Sub Category"
            onChange={(selectedOption) =>
              handleSelectChange(selectedOption, { name: "sub_category_id", labelName: "sub_category_name" })
            }
            isSearchable={true}
            styles={{
              control: (provided) => ({
                ...provided,
                borderRadius: "10px",
              }),
            }}
          />
        </div>
      </div>
      <br/>
      {/* Other Input Fields */}
      <div className="row mb-4">
        <div className="col">
          <label htmlFor="food_name" style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>Food Name</label>
          <input
            type="text"
            className="form-control"
            name="food_name"
            placeholder="Food Name"
            value={formData.food_name}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="col">
          <label htmlFor="food_code" style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>Food Code</label>
          <input
            type="text"
            className="form-control"
            name="food_code"
            placeholder="Food Code"
            value={formData.food_code}
            onChange={handleInputChange}
            required
          />
        </div>
      </div>

      <div className="row mb-4">
        <div className="col">
          <label htmlFor="description" style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>Food Description</label>
          <input
            type="text"
            className="form-control"
            name="description"
            placeholder="Food Description"
            value={formData.description}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="col">
           <label htmlFor="uom" style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>Food UOM</label>
          <input
            type="text"
            className="form-control"
            name="uom"
            placeholder="Food uom"
            value={formData.uom}
            onChange={handleInputChange}
            required
          />
        </div>
      </div>

      <div className="row mb-4">
        <div className="col">
           <label htmlFor="price" style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>Regular Price</label>
          <input
            type="number"
            className="form-control"
            name="price"
            placeholder="Food Price"
            value={formData.price}
            onChange={handleInputChange}
            required
            min="0.1"
            step="0.1"
          />
        </div>

        <div className='col'>
        <label htmlFor="organic_price" style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>Organic Price</label>
          <input
            type="number"
            className="form-control"
            name="organic_price"
            placeholder="Food Price"
            value={formData.organic_price}
            onChange={handleInputChange}
            required
            min="0.1"
            step="0.1"
          />
        </div>
      </div>

      <div className='row mb-2'>
        <div className='col'>
           <label htmlFor="food_image" style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>Food Image</label>
          <input 
  type="file" 
  className="form-control" 
  id="formFile" 
  onChange={handleImageChange} 
  name="food_image" 
  style={{borderRadius: "10px"}}
/>
        </div>
        <div className='col'>
          <div className="d-flex gap-3 mt-3">
      <div className="form-check">
  <input
    className="form-check-input"
    type="checkbox"
    id="is_additional_notes"
    name="is_additional_notes"
    checked={formData.is_additional_notes === 1}
    onChange={(e) =>
      setFormData({
        ...formData,
        is_additional_notes: e.target.checked ? 1 : 0,
      })
    }
  />
  <label className="form-check-label" htmlFor="is_additional_notes" style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>
    Is Additional Notes
  </label>
</div>

<div className="form-check">
  <input
    className="form-check-input"
    type="checkbox"
    id="is_group"
    name="is_group"
    checked={formData.is_group}
    onChange={handleCheckboxChange}
  />
  <label className="form-check-label" htmlFor="is_group" style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>
    Is Group
  </label>
</div>

<div className="form-check">
  <input
    className="form-check-input"
    type="checkbox"
    id="is_billing"
    name="is_billing"
    checked={formData.is_billing}
     onChange={(e) =>
      setFormData({
        ...formData,
        is_billing: e.target.checked ? 1 : 0,
      })
    }
  />
  <label className="form-check-label" htmlFor="is_billing" style={{ color: "green", fontFamily: "serif", fontWeight: "bolder" }}>
    Is Billing
  </label>
</div>
</div>
        </div>
      </div>

      

<br/>

{formData.is_group == true && (
  <div className="card mt-1 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '10px', width:"auto", height:"auto" }}>
    <h5 style={{ fontFamily: "serif", color: "green", fontSize:"15px" }}>Group Items</h5>

    {/* {formData.group_items?.map((item, idx) => ( */}
      <div 
      // key={idx} 
      className="border rounded p-3 mb-3">
        <div className="row mb-2">
          <div className="col">
            <label style={{ fontWeight: "bold" }}>Name</label>
            <input
              type="text"
              className="form-control"
             value={formData.group_items[0].name}
              onChange={(e) => handleGroupItemChange('name', e.target.value)}
            />
          </div>
          <div className="col">
            <label style={{ fontWeight: "bold" }}>Remarks</label>
            <input
              type="text"
              className="form-control"
              value={formData.group_items[0].remarks}
              onChange={(e) => handleGroupItemChange('remarks', e.target.value)}
            />
          </div>
        </div>
        <div className="row mb-2">
          <div className="col">
            <label style={{ fontWeight: "bold" }}>Image</label>
            <input
              type="file"
              className="form-control"
              onChange={(e) => handleGroupImageChange( e.target.files[0])}
            />
          </div>
        </div>

         {/* is_sub_group Checkbox */}
      <div className="form-check mb-3">
        <input
          className="form-check-input"
          type="checkbox"
          id="is_sub_group"
          checked={formData.is_sub_group === 1}
          onChange={(e) =>
            setFormData({
              ...formData,
              is_sub_group: e.target.checked ? 1 : 0,
            })
          }
        />
        <label
          className="form-check-label"
          htmlFor="is_sub_group"
          style={{ fontWeight: "bold", fontFamily: "serif", color: "green" }}
        >
          Is Sub Group
        </label>
      </div>

 {/* Sub Group Form */}
      {formData.is_sub_group === 1 && (
        <div className="card p-3" style={{ backgroundColor: '#e9f7ef', border: "1px dashed green", width:"auto", height:"auto" }}>
          <h6 style={{ fontWeight: "bold", color: "green" }}>Sub Group Details</h6>
          <div className="row mb-2">
            <div className="col">
              <label style={{ fontWeight: "bold" }}>Sub Group Name</label>
              <input
                type="text"
                className="form-control"
                onChange={(e) => handleSubGroupChange('name', e.target.value)}
              />
            </div>
            <div className="col">
              <label style={{ fontWeight: "bold" }}>Sub Group Remarks</label>
              <input
                type="text"
                className="form-control"
                onChange={(e) => handleSubGroupChange('remarks', e.target.value)}
              />
            </div>
          </div>
        </div>
      )}
      </div>
    {/* )
    )
    } */}

    {/* <button
      className="btn btn-sm btn-outline-primary"
      onClick={handleAddGroupItem}
    >
      + Add Group Item
    </button> */}
  </div>
)}




      <br />
      {postLoading ? (
          <span>Loading...</span>
        ) : (
          <button type="submit" className="btn btn-success" style={{ borderRadius: "10px",float:"right",marginRight:"5px" }}>
            Create
          </button>
        )}
          <button className="btn btn-danger" onClick={()=>setCreate(false)} style={{borderRadius:"10px",float:"right",marginRight:"5px"}}>Cancel</button>
    </form>
       
        </Modal.Body>
      </Modal> 


            {/* </div> */}
       </Layout></>

        
    )
}

export default CreateFood;